module.exports = __webpack_public_path__ + "img/3.82117c07.jpg";